module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-capoeira.json
// module id = 361
// module chunks = 122808840030588